import { DoubleSide, Euler, Mesh, MeshBasicMaterial, Quaternion, Sphere, SphereGeometry, Vector3 } from 'three';
import { ActionControllerEventName, ParentEvent, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import * as styleConfig from '../../styleConfig';
import { SliderComponent, SlidingMode } from '../../components/SliderComponent';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class DistilledWaterModule extends ViewerModule {
    constructor(model, table, uiContainer, level) {
        super();
        this.level = level;
        this.drops = [];
        this.dropsMaterial = new MeshBasicMaterial({ color: 'blue' });
        this.dropsGeometry = new SphereGeometry(0.03);
        this.uiObject.name = 'DistilledWaterModule';
        this.model = model;
        this.defaultPosition = model.position.clone();
        this.table = table;
        // this.addObject(this.uiContainer = uiContainer);
        this.uiContainer = uiContainer;
        model.material.forEach(material => material.side = DoubleSide);
        const debugPoint1 = window['debugPoint1'] = new Mesh(new SphereGeometry(0.1), new MeshBasicMaterial({ color: 'red', visible: false }));
        const debugPoint2 = window['debugPoint2'] = new Mesh(new SphereGeometry(0.1), new MeshBasicMaterial({ color: 'red', visible: false }));
        this.addObject(debugPoint1, null, this.model);
        this.addObject(debugPoint2, null, this.model);
        const topPoint = new Vector3(-0.2454, 0.67, -0.015580);
        const bottomPoint = new Vector3(0.243, -0.68, -0.01);
        debugPoint1.position.copy(topPoint); // (-0.2454, 0.67, -0.015580);
        debugPoint2.position.copy(bottomPoint); // (0.243, -0.68, -0.01);
        this.onUpdateCallback = () => {
            if (this.model.localToWorld(topPoint.clone()).y <= this.model.localToWorld(bottomPoint.clone()).y) {
                let drop;
                this.drops.push(drop = new Mesh(this.dropsGeometry, this.dropsMaterial));
                Viewer.scene.add(drop);
                drop.scale.multiplyScalar(Math.random() + 0.5);
                drop.position.copy(this.model.localToWorld(topPoint.clone()));
                drop.userData.sphere = new Sphere(drop.position, 0.03 * drop.scale.x);
            }
            this.drops.slice().forEach(drop => {
                drop.position.y -= 0.05;
                if (drop.position.y < -18.9) {
                    this.removeDrop(drop);
                }
                else {
                    drop.userData.sphere.center.copy(drop.position);
                }
            });
        };
        // this.setDynamicLiquidMode(true);
    }
    setDynamicLiquidMode(enabled) {
        if (enabled) {
            Viewer.on('update', this.onUpdateCallback);
        }
        else {
            this.onUpdateCallback && Viewer.off('update', this.onUpdateCallback);
            this.drops.slice().forEach(drop => this.removeDrop(drop));
        }
    }
    initSlider() {
        if (this.sliderComponent) {
            this.sliderComponent.closeViewer();
        }
        const sliderOptions = {
            mode: SlidingMode.onlyToRight,
            border: true,
            magnetOnSides: 0.03,
            size: {
                width: 2,
                height: 0.2
            },
            picker: new IconButtonComponent({
                diameter: 0.3,
                text: '',
                textColor: styleConfig.SLIDER_PICKER_TEXT_COLOR.getStyle(),
                background: styleConfig.BUTTON_PRIMARY_COLOR.getStyle()
            }),
            filledPart: {
                border: 0.02,
                radius: 0.1,
                borderColor: styleConfig.SLIDER_BORDER_COLOR,
                mainColor: styleConfig.SLIDER_FILLED_COLOR,
            },
            unfilledPart: {
                border: 0.02,
                radius: 0.1,
                borderColor: styleConfig.SLIDER_BORDER_COLOR,
                mainColor: styleConfig.SLIDER_UNFILLED_COLOR,
            }
        };
        this.sliderComponent = new SliderComponent(sliderOptions);
        this.sliderComponent.uiObject.name = 'SliderComponent';
        this.sliderComponent.uiObject.rotateZ(-Math.PI / 2);
        this.sliderComponent.uiObject.position.set(-1.24, -2, 4.2);
        this.sliderComponent.uiObject.visible = false;
        this.uiContainer.add(this.sliderComponent.uiObject);
        if (Viewer.controls.zController) {
            this.sliderComponent.uiObject.position.set(3, 0, 0);
            this.sliderComponent.uiObject.scale.setScalar(2.5);
        }
    }
    visibilityShadow(visibility = true) {
        const pPlane = this.model.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    initWaitSelect() {
        if (Viewer.controls.zController) {
            PreparationPickingObjects.saveObjectState(this.model);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.model, () => {
                if (!this.level.interaction)
                    return;
                Viewer.scene.add(this.model);
                this.visibilityShadow(false);
                this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.model, () => {
                    PreparationPickingObjects.flyObjectToPrevState(this.model);
                });
                this.fire('selected');
            });
        }
        else {
            this.actionController.once(ActionControllerEventName.click, this.model, () => {
                if (Viewer.controls.zController)
                    return;
                Viewer.pointerController.setObject(this.model);
                this.visibilityShadow(false);
                this.model.geometry.rotateZ(1.5);
                this.model.geometry.translate(0.7, 0.3, 0);
                this.fire('selected');
            });
        }
    }
    setDefaultPositionRotation() {
        if (!Viewer.controls.zController) {
            this.model.geometry.translate(-0.25, 0.66, 0);
            this.model.position.add(new Vector3(0.25, -0.66, 0));
        }
        else {
            const localPosition = this.table.worldToLocal(this.model.position.clone());
            this.table.add(this.model);
            this.model.position.copy(localPosition);
        }
        this.flyTo(this.defaultPosition, 600, () => this.visibilityShadow(true));
        this.rotateTo(new Euler(), 600);
    }
    flyToFunnel() {
        if (Viewer.controls.zController) {
            this.setDynamicLiquidMode(true);
            return;
        }
        Viewer.pointerController.setObject(null);
        this.table.add(this.model);
        this.model.rotation.set(0, 0, 0);
        this.model.geometry.translate(-0.7, -0.3, 0);
        this.model.geometry.rotateZ(-1.5);
        this.model.geometry.translate(0.25, -0.66, 0);
        this.model.position.add(new Vector3(-0.25, 0.66, 0));
        const duration = 0;
        this.model.position.set(-0.3, 5.33, 1.4);
        this.model.rotation.set(0, 0, 0.68);
        // this.flyTo(new Vector3(-0.3, 5.33, 1.4), duration);
        // this.rotateTo(
        //     new Euler(0, 0, 0.68),
        //     duration,
        //     0,
        //     () => {
        this.initSlider();
        let prevSliderValue = -1;
        this.sliderComponent.value = 0;
        this.sliderComponent.uiObject.visible = true;
        this.sliderComponent.on('change', (event) => {
            if (event.data === prevSliderValue)
                return;
            prevSliderValue = event.data;
            this.model.rotateZ(event.data / 100);
            this.fire('filling', new ParentEvent('filling', event.data));
        });
        this.sliderComponent.on('completed', () => {
            this.sliderComponent.uiObject.visible = false;
            this.fire('flask_filled');
        });
    }
    flyTo(pos, time = 600, onComplete) {
        new Tween(this.model.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onComplete(() => onComplete && onComplete())
            .start();
    }
    rotateTo(newEuler, time = 600, delay = 0, onComplete) {
        const oldQuaternion = this.model.quaternion.clone();
        const newQuaternion = new Quaternion().setFromEuler(newEuler);
        new Tween({ alpha: 0 })
            .to({ alpha: 1 }, time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((alpha) => {
            const quat = oldQuaternion.clone().slerp(newQuaternion.clone(), alpha);
            this.model.quaternion.copy(quat);
        })
            .onComplete(() => onComplete && onComplete())
            .delay(delay)
            .start();
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
    removeDrop(drop) {
        drop.parent && drop.parent.remove(drop);
        this.drops.splice(this.drops.indexOf(drop), 1);
    }
    dispose() {
        super.dispose();
        this.drops.forEach(drop => {
            drop.parent && drop.parent.remove(drop);
        });
        this.dropsGeometry.dispose();
        this.dropsMaterial.dispose();
    }
}
